import { render, staticRenderFns } from "./PatientTransferCheck.vue?vue&type=template&id=5a3fa8d9&scoped=true&"
import script from "./PatientTransferCheck.vue?vue&type=script&lang=js&"
export * from "./PatientTransferCheck.vue?vue&type=script&lang=js&"
import style0 from "./PatientTransferCheck.vue?vue&type=style&index=0&id=5a3fa8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3fa8d9",
  null
  
)

export default component.exports